import React from "react";
import * as Icons from "lucide-react";
import { CheckCircle2, Eye } from "lucide-react";
import { procedures, otherConditions } from "../mock";

export default function Procedures() {
  return (
    <section id="tratamientos" className="bg-[#f6f8fc]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="max-w-2xl reveal">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#1d6fc0]">
            Procedimientos especializados
          </span>
          <h2 className="font-display font-extrabold text-3xl lg:text-[2.6rem] leading-tight mt-4 text-[#0b2545]">
            Alta complejidad para tu salud visual
          </h2>
          <p className="text-slate-500 mt-4 leading-relaxed">
            Contamos con unidades especializadas y procedimientos de alta complejidad para el
            manejo integral de la retina, el glaucoma y otras patologías oculares.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mt-14">
          {procedures.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Activity;
            return (
              <div
                key={p.unit}
                className="reveal card-hover rounded-2xl bg-white border border-slate-200 p-7"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#0b2545] grid place-items-center text-blue-200">
                  <Icon size={22} />
                </div>
                <h3 className="font-display font-bold text-lg mt-5 text-[#0b2545]">{p.unit}</h3>
                <ul className="mt-4 space-y-2.5">
                  {p.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-sm text-slate-600">
                      <CheckCircle2 size={17} className="text-[#1d6fc0] shrink-0 mt-0.5" />
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="reveal mt-8 rounded-2xl border border-slate-200 bg-white p-7">
          <div className="flex items-center gap-2 text-[#0b2545] font-display font-bold">
            <Eye size={18} className="text-[#1d6fc0]" /> Otras afecciones oculares comunes
          </div>
          <div className="flex flex-wrap gap-2.5 mt-4">
            {otherConditions.map((c) => (
              <span
                key={c}
                className="text-sm font-medium px-4 py-1.5 rounded-full bg-[#e8f2fd] text-[#1d6fc0]"
              >
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
